import { useTranslation } from "react-i18next";
import { FiShare2 } from "react-icons/fi";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { ResturantData } from "@/types/globalTypes";
import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import { useUserRole } from "@/hooks/useUserRole";
import { navigateToSubscribtion } from "@/utils/helpers";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Logo() {
  const { t, i18n } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const ResturantData = useSelector(
    (state: { resturant: { resturantData: ResturantData } }) =>
      state.resturant.resturantData,
  );
  const isPublishedMenu = ResturantData?.published;

  const { isAdmin, isBranchAdmin } = useUserRole();
    const navigate = useNavigate();
  const token = useSelector(
  (state: { auth: { token: string } }) => state.auth.token,
);

  // const [isHovered, setIsHovered] = useState(false);
  
  const WithoutPlan = ResturantData?.subscription === null
  const isFreePlan = ResturantData?.subscription?.isFree;
  const availableToUseLink =   isPublishedMenu

  const handleShare = async () => {
    if (!availableToUseLink) return;
    const link = ResturantData?.menuUrl;
    const title = t("logos.shareTitle");

    if (Capacitor.getPlatform() === "web") {
      if (navigator.share) {
        navigator
          .share({ title, url: link })
          .catch(() => toast.error(t("logos.shareError")));
      } else {
        toast.error(t("logos.unsupportedShare"));
      }
    } else {
      await Share.share({ title, url: link });
    }
  };

  return (
    <div className="mb-[0.75rem] flex flex-col items-center justify-center">
      <h4 className="text-xl font-bold text-[#BAF3FD]">
        {i18n.language === "ar"
          ? ResturantData?.nameAR || t("logos.restaurantName")
          : ResturantData?.nameEN || t("logos.restaurantName")}
      </h4>

      {(isAdmin || isBranchAdmin) && (
        <>
          <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="relative mt-2 flex items-center justify-center rounded-[12px] border-2 border-sky-200">
            <div
              className="relative"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={(e) => {
                if (!availableToUseLink) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            >
              <button className="group flex items-center justify-between gap-3 rounded-[10px] text-white transition-colors hover:bg-skyblue hover:text-[#1B2B34]">
                <a
                  href={availableToUseLink ? ResturantData?.menuUrl : "#"}
                  target="_blank"
                  onClick={(e) => {
                    if (!availableToUseLink) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                  className="flex items-center gap-2 py-[1px] text-sm"
                >
                  <span
                    className={`ms-1 flex h-[23px] min-w-[40px] items-center justify-center rounded-[12px] border-[2px] bg-[#BAF3FD] text-center text-base font-bold text-[#1B2B34] ${
                      WithoutPlan ? "border-red-700 text-sm" : isFreePlan ? "border-orange-400 text-sm" : "border-sky-300"
                    }`}
                  >
                    <span
                      className={`mb-[2px] w-full ${isFreePlan || WithoutPlan ? "p-1" : ""}`}
                    >
                      {WithoutPlan ? t("logos.noPlan") : isFreePlan ? t("logos.trial") : t("logos.pro")}
                    </span>
                  </span>
                  <span className="block text-base font-semibold text-skyblue group-hover:text-sidebar">
                    {t("logos.visitMenu")}
                  </span>
                </a>

                <FiShare2
                  onClick={(e) => {
                    if (!availableToUseLink) {
                      e.preventDefault();
                      e.stopPropagation();
                    } else {
                      handleShare();
                    }
                  }}
                  className="h-[1.8rem] w-[2.2rem] cursor-pointer rounded-e-[10px] rounded-s-[10px] border-s-2 border-sky-200 bg-[#BAF3FD] p-[7px] text-[#1B2B34] transition-colors hover:bg-[#1B2B34] hover:text-white"
                />
              </button>


              {!availableToUseLink && isHovered && (
                <div
                  className={`absolute left-1/2 z-[999] w-[200px] font-semibold text-center border border-sidebar ${
                    i18n.language === "ar" ? "bottom-[-55px]" : "bottom-[-55px]"
                  } -translate-x-1/2 rounded-md bg-skyblue px-3 py-2 text-xs text-sidebar`}
                >
                  {t("logos.publishMenuTooltip")}
                  <div className="absolute left-1/2 top-0 -translate-x-1/2 border-[6px] border-transparent border-t-skyblue"></div>
                </div>
              )}

            </div>
          </div>

          {WithoutPlan && (
            <button
            type="button"
              onClick={() => navigateToSubscribtion(navigate,token)}
              className="mt-2 block text-center text-sm text-[#BAF3FD] hover:underline"
            >
              {t("logos.subscribeNow")}
            </button>
          )}
        </>
      )}
    </div>
  );
}
